export const placeOrderFormData = [
  {
    id: 'customer-details',
    heading: 'Customer details',
    className: '',
    fields: [
      {
        id: 'company-name',
        name: 'companyName',
        type: 'SINGLE_SELECT_WITH_SEARCH',
        displayName: '',
        value: '',
        error: '',
        options: [],
        validation: {
          rule: {
            required: { isRequired: true }
          }
        }
      },
      {
        id: 'customer-name',
        name: 'customerName',
        type: 'TEXT',
        displayName: '',
        value: '',
        error: '',
        disabled: true
      },
      {
        id: 'email',
        name: 'email',
        type: 'TEXT',
        displayName: '',
        value: '',
        error: '',
        disabled: true
      },
      {
        id: 'gst',
        name: 'gst',
        type: 'TEXT',
        displayName: '',
        value: '',
        error: '',
        disabled: true
      },
      {
        id: 'phoneNumber',
        name: 'phoneNumber',
        type: 'TEXT',
        displayName: '',
        value: '',
        error: '',
        disabled: true
      }
    ]
  },
  {
    id: 'payment-details',
    heading: 'Payment details',
    className: 'payment-details-section',
    fields: [
      {
        id: 'payment-type',
        name: 'paymentType',
        type: 'SINGLE_SELECT',
        displayName: '',
        value: '',
        error: '',
        options: [
          {
            name: 'Prepaid',
            value: 'PREPAID'
          },
          {
            name: 'Postpaid',
            value: 'POSTPAID'
          }
        ],
        validation: {
          rule: {
            required: { isRequired: true }
          }
        }
      }
    ]
  },
  {
    id: 'product-details',
    heading: 'Product details',
    className: 'product-details-section',
    fields: [
      {
        id: 'product-name',
        name: 'productName',
        type: 'SINGLE_SELECT_WITH_SEARCH',
        displayName: '',
        value: '',
        error: '',
        options: [],
        validation: {
          rule: {
            required: { isRequired: true }
          }
        }
      },
      {
        id: 'price',
        name: 'price',
        type: 'NUMBER',
        displayName: '',
        value: '',
        error: '',
        validation: {
          rule: {
            required: {
              isRequired: true
            },
            regex: {
              pattern: /^\d+$/
            }
          }
        }
      },
      {
        id: 'quantity',
        name: 'quantity',
        type: 'NUMBER',
        displayName: '',
        value: '1',
        error: '',
        validation: {
          rule: {
            required: {
              isRequired: true
            },
            regex: {
              pattern: /^[1-9]\d*$/
            }
          }
        }
      },
      {
        id: 'additional-information',
        name: 'additionalInformation',
        type: 'TEXTAREA',
        displayName: '',
        placeHolder: 'Enter additional information',
        value: '',
        error: '',
        validation: {
          rule: {
            required: {
              isRequired: false
            },
            length: {
              max: 300
            }
          }
        }
      },
      {
        id: 'add-product',
        name: 'addProduct',
        type: 'BUTTON',
        label: '',
        className: 'add-product-btn',
        mode: 'primary'
      }
    ]
  }
];
